module.exports = __webpack_public_path__ + "img/payment_fps_md.ca70650d.png";